/**
 * DevExtreme (esm/renovation/ui/pager/common/consts.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var PAGER_CLASS = "dx-pager";
export var LIGHT_MODE_CLASS = "dx-light-mode";
export var PAGER_PAGES_CLASS = "dx-pages";
export var PAGER_PAGE_INDEXES_CLASS = "dx-page-indexes";
export var PAGER_PAGE_CLASS = "dx-page";
export var PAGER_SELECTION_CLASS = "dx-selection";
export var PAGER_PAGE_SIZE_CLASS = "dx-page-size";
export var PAGER_PAGE_SIZES_CLASS = "dx-page-sizes";
export var PAGER_SELECTED_PAGE_SIZE_CLASS = "".concat(PAGER_PAGE_SIZE_CLASS, " ").concat(PAGER_SELECTION_CLASS);
export var FIRST_CHILD_CLASS = "dx-first-child";
